// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media(max-width:1023.98px){.CatalogSubCategories__content>.row>div>.CatalogSubCategoryBox{width:100%}.CatalogSubCategories__content>.row>div>.CatalogSubCategoryBox:after{display:none}}.CatalogSubCategories__content>.row>.no-after>.CatalogSubCategoryBox:after{display:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
